<template>
  <v-form ref="form" :value="valid" @input="v => $emit('update:valid', v)">
    <v-row align="center">
      <v-col cols="12" sm="4">
        <v-autocomplete
          :items="getUniqueTags"
          solo
          hide-details
          :value="supplier_tag"
          @change="v => $emit('update:supplier_tag', v)"
          label="# identifiant le fournisseur"
          prepend-icon="fa-hashtag"
        ></v-autocomplete>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SuppliersStoreTag",
  props: {
    supplier_tag: {
      type: String,
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getProducts", "getRecipes", "getTagCategories"]),
    getUniqueTags() {
      return [
        ...new Set([
          ...this.getRecipes
            .filter(x => x.data !== null)
            .map(x => x.data.tags)
            .flat(),
          ...this.getProducts
            .filter(x => x.data !== null)
            .map(x => x.data.tags)
            .flat(),
          ...this.getTagCategories.map(x => x.tags).flat()
        ])
      ];
    }
  }
};
</script>

<style></style>
